const PLAIN_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
export function isPlainDate(value) {
    if (!PLAIN_DATE_RE.test(value))
        return false;
    const [y, m, d] = value.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d;
}
export function toPlainDate(date, timeZone) {
    // en-CA даёт формат YYYY-MM-DD; часовой пояс применяется здесь и только здесь.
    return new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}
export function today(timeZone, now = new Date()) {
    return toPlainDate(now, timeZone);
}
export function addDays(date, days) {
    const [y, m, d] = date.split('-').map(Number);
    const shifted = new Date(Date.UTC(y, m - 1, d + days));
    return shifted.toISOString().slice(0, 10);
}
export function compareDates(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Просроченной считается только задача с истёкшим сроком (`dueDate`).
 * Сдвиг плановой даты (`scheduledFor`) просрочкой не является —
 * это перепланировка (docs/PRODUCT.md, раздел 3).
 */
export function isOverdue(dueDate, todayDate) {
    if (!dueDate)
        return false;
    return compareDates(dueDate, todayDate) < 0;
}
/** Начало недели по локальной дате. weekStartsOn: 1 — понедельник, 0 — воскресенье. */
export function startOfWeek(date, weekStartsOn) {
    const [y, m, d] = date.split('-').map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    const diff = (dt.getUTCDay() - weekStartsOn + 7) % 7;
    return addDays(date, -diff);
}
//# sourceMappingURL=dates.js.map